import React, { CSSProperties, useEffect, useRef } from 'react';
import './wizard.style.scss';
import { __SLPWizardProps } from './wizard.interface';
import { FormShowType, TextDirection } from 'interface';
import SLPSlider from 'utilities/slp/slider/slider.index';

const SLPWizard: React.FC<__SLPWizardProps> = function (props: __SLPWizardProps) {
    const rtl = props.form.direction === TextDirection.rtl;
    const vertical = props.form.show_type === FormShowType.multiple;
    const pageQuestionRef = useRef<{ [key: number]: HTMLDivElement | null }>({});
    const questions = [...props.questions];
    const pageRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if ((props.form.show_type === FormShowType.multiple, pageRef.current)) pageRef.current.scrollIntoView();
    }, [props.sectionIndex]);

    if (vertical) {
        const section = props.form.sections.find((section) =>
            section.questions.map((question) => question.id).includes(props.questions[0].id),
        );

        const style: CSSProperties = {};
        if (section?.bg_image_file && props.form.show_type === FormShowType.multiple) {
            style.backgroundImage = `url('${section.bg_image_file.file}')`;
        }
        return (
            <div ref={pageRef} style={style} className={`ucheck-slp-page ${props.className ? props.className : ''}`}>
                {questions.map((item, index) => {
                    return (
                        <div
                            ref={(ref) => {
                                pageQuestionRef.current[item.id] = ref;
                            }}
                            key={'single' + item.id}
                        >
                            {props.layout(item, !rtl && !vertical ? questions.length - index - 1 : index)}
                        </div>
                    );
                })}
            </div>
        );
    }
    return (
        <SLPSlider dir={props.form.direction} step={props.wizardIndex}>
            {questions.map((item, index) => (
                <div key={'page' + item.id}>{props.layout(item, index)}</div>
            ))}
        </SLPSlider>
    );
};

export default SLPWizard;
